//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from './title'
import  Details  from "./monthly/details.vue";
import { InsurStore } from '../store'

    export default {
        name:'InDetails',
        data() {
            return {
                show: false,
                list:[]
            }
        },
        components: {
            InTitle,
            Details
        },
        computed: {
            cache() {
                return InsurStore.insurance.cache
            }
        },
        created(){
            this.list = this.cache.product_list
        },
        methods: {
            details() {
                this.STATISTICS_CONFIG.insur_proinfo_insurdetail_click()
                this.show = false;
                this.$nextTick(()=>{
                    this.show = true
                })
            }
        }
    }
